type IParam = "templateId" | "recipient" | "envelopeId" | 'type' |'firstname'|'lastname'|'email'; // please add the query for the envelop id here

export const GetQueryParams = (param: IParam) => {
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get(param);
  return myParam;
};
